import React, { Component } from "react"

/* Constants */
import { env } from "../constants"

/* Component Avatar */
class Avatar extends Component {

    constructor() {
        super()

        this.state = {
            loading: false
        }
    }

    render = () => {

        /* Fields */
        const { uri, size } = this.props
        const { loading } = this.state

        const style = size ? { width: size, height: size } : {}
        const imgStyle = size ? { width: size / 1.4, height: size / 1.4 } : {}

        if (!uri) {
            return (
                <div className="default-avatar-box" style={style}>
                    <img className="default-avatar" src="/images/profile-filled.png" alt="Avatar" style={imgStyle} />
                </div>
            )
        }

        return (
            <div className="default-avatar-box" style={style}>
                <img className="default-avatar" src="/images/profile-filled.png" alt="Avatar" style={{ position: "absolute", opacity: loading ? 0 : 0.5, ...imgStyle }} />
                <img className="avatar" src={`${env.point}/members/${uri}`} alt="Avatar" onLoad={() => this.setState({ loading: true })} style={{ opacity: loading ? 1 : 0, ...imgStyle }} />
            </div>
        )
    }

}

export default Avatar